import {READING_ROPE_DOMAIN} from '../../../../../../../constants/assessmentConfigPageConstants'

export default {
  name: 'Letter Naming And Sounds',
  description: 'The student is required to know all the letter naming and sounds.',
  reading_rope_domain: [
    READING_ROPE_DOMAIN.DYSLEXIA_RISK
  ],
  configuration: [
    true, 
    true,
    false,
    false, 
    false,
    false,
    false,
  ],
  licenseTableName: 'letterNamingAndSoundsConfig',
} 